import React, { Component } from 'react';
import _ from 'lodash';
import { enableES5 } from 'immer';
import { Provider, Observer } from 'mobx-react';
import styled from 'styled-components';
import { ThemeProvider } from '@material-ui/core/styles';
import Cookies from 'universal-cookie';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter as Router, Route, Switch, Link, NavLink, Redirect } from 'react-router-dom';
import SingleOrderShipmentContainer from './containers/SingleOrderShipmentContainer';
import DeliveryMonitorContainer from './containers/DeliveryMonitorContainer';
import SettingsContainer from './containers/SettingsContainer';
import ShipmentSearchContainer from './containers/ShipmentSearch';
import ReportContainer from './containers/ReportContainer';
import Report from './components/ReportComponents/Report';
import ClaimsContainer from './containers/ClaimsContainer';
import BatchContainer from './containers/BatchContainer';
import BatchDetail from './containers/BatchDetail';
import UpdatesDetail from './containers/UpdatesDetail';
import ClaimsInstructions from './components/claims/ClaimsInstructions';
import DashboardContainer from './containers/DashboardContainer';

import { lightTheme } from './themes';
import { stores } from './stores';
import { performLogout } from './stores/api';
import { StorageKeys } from './stores/Storage';

import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import Header from './layout/Header';

export const LinkItem = styled(Link)`
  display: block;
  border: none;
  text-align: left;
  cursor: pointer;
  font-family: 'AvenirNext';
  font-size: 13px;
  letter-spacing: -0.1px;
  color: #7a8396;
  padding: 10px 15px;
  border-bottom: 1px solid #ccc;
  background-color: #fff;
  text-decoration: none;
  &:nth-last-child(1) {
    border-bottom: none;
  }
  &:hover {
    background-color: #f7f7f7;
  }
`;

export const MenuItem = styled(NavLink)`
  padding: 0 20px;
  cursor: pointer;
  display: block;
  font-family: AvenirNext;
  font-size: 12px;
  text-align: right;
  color: #ffffff;
  line-height: 40px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  transition: all 0.3s ease 0s;
  text-decoration: none;
  &:hover {
    background: #332c4e;
  }
  @media (min-width: 992px) {
    width: 150px;
    display: inline-block;
    text-align: center;
    padding: 0;
    &.selected {
      border-bottom-color: #fff;
    }
  }
`;

const cookies = new Cookies();

enableES5();
class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isHideMainMenu: false,
      isBlur: cookies.get(StorageKeys.BLUR) === 'true',
      isBlurAddress: cookies.get(StorageKeys.BLUR_ADDRESS) === 'true',
    };

    this.keys = {};
    this.logout = this.logout.bind(this);
  }

  componentDidMount() {
    if (typeof document !== 'undefined' && document) {
      document.addEventListener('keydown', this.handleKeyEvent, false);
    }

    stores.userStore.getUser();
    stores.userStore.getClientSettings();

    stores.userStore.setBlurCustomerInfo(cookies.get(StorageKeys.BLUR) === 'true');
    stores.userStore.setBlurCustomerAddress(cookies.get(StorageKeys.BLUR_ADDRESS) === 'true');
  }

  componentWillUnmount() {
    if (typeof document !== 'undefined' && document) {
      document.removeEventListener('keydown', this.handleKeyEvent, false);
    }
  }

  handleKeyEvent = (event) => {
    const { key, shiftKey, metaKey, ctrlKey } = event || Event; // to deal with IE

    if (key === 'H' && shiftKey && metaKey && ctrlKey) {
      const isBlur = !this.state.isBlur;
      this.setState({ isBlur: isBlur });
      stores.userStore.setBlurCustomerInfo(isBlur);
    }

    if (key === 'F' && shiftKey && metaKey && ctrlKey) {
      const isBlur = !this.state.isBlurAddress;
      this.setState({ isBlurAddress: isBlur });
      stores.userStore.setBlurCustomerAddress(isBlur);
    }
  };

  toggleMainMenu = () => this.setState({ isHideMainMenu: !this.state.isHideMainMenu });

  async logout() {
    await performLogout(import.meta.env.REACT_APP_OAUTH_URL);
    window.location.href = `${import.meta.env.REACT_APP_OAUTH_URL}/login?logout=true&next=${encodeURI(window.location.href)}`;
  }

  render() {
    const { isBlur } = this.state;

    return (
      <ThemeProvider theme={lightTheme}>
        <Provider {...stores}>
          <Router>
            <div className="App">
              <Header userStore={stores.userStore} isBlur={isBlur} />

              <div className="main-content" style={{ background: lightTheme.colorTokens.surface}}>
                <Switch>
                  <Route path="/updates" component={UpdatesDetail} />
                  {/* <Route path="/shipments/new-order" component={SingleOrderShipmentContainer} /> */}
                  {/* <Route path="/shipments/:id/edit" component={ShipmentNewOrderContainer} /> */}
                  {/* <Route path="/shipments/:id" component={ShipmentListContainer} /> */}
                  {/* <Route path="/shipments" component={ShipmentListContainer} /> */}
                  <Route path="/dashboards/:id" component={DashboardContainer} />
                  <Route path="/dashboards" component={DashboardContainer} />
                  <Route path="/deliveries/:day/:region/:shipmentId" render={(props) => <DeliveryMonitorContainer {...props} isBlur={isBlur} />} />
                  <Route path="/deliveries/:day/:region" render={(props) => <DeliveryMonitorContainer {...props} isBlur={isBlur} />} />
                  <Route path="/deliveries" render={(props) => <DeliveryMonitorContainer {...props} isBlur={isBlur} />} />
                  <Route path="/batch/new-order" render={(props) => stores.userStore.isReadOnly ? <DeliveryMonitorContainer {...props} /> : <SingleOrderShipmentContainer {...props} />} />
                  <Route path="/batch" exact render={(props) => stores.userStore.isReadOnly ? (stores.userStore.isStoreUser ? <SingleOrderShipmentContainer {...props} /> : <DeliveryMonitorContainer {...props} />) : <BatchContainer {...props} />} />
                  <Route path="/batch/:id" render={(props) => <BatchDetail {...props} isBlur={isBlur} />} />
                  <Route path="/settings" render={(props) => stores.userStore.isReadOnly ? <DeliveryMonitorContainer {...props} /> : <SettingsContainer {...props} />} />
                  <Route path="/search" render={(props) => <ShipmentSearchContainer {...props} />} />
                  <Route path="/reports/:id" render={(props) => <Report {...props} />} />
                  <Route path="/reports" render={(props) => <ReportContainer {...props} />} />
                  <Route path="/claims/instructions" render={(props) => <ClaimsInstructions {...props} />} />
                  <Route path="/claims" render={(props) => <ClaimsContainer {...props} />} />
                  <Redirect from="/" to="/deliveries" />
                </Switch>
              </div>
              <ToastContainer autoClose={1500} theme="colored" icon={false} />
            </div>
          </Router>
        </Provider>
      </ThemeProvider>
    );
  }
}

export default App;
